var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-navigation',{ref:"drawer",attrs:{"items":_vm.items,"title":_vm.title,"img":_vm.img}}),_c('app-bar',{attrs:{"items":_vm.items,"title":_vm.title,"img":_vm.img},on:{"drawer":() => (_vm.$refs.drawer.drawer = !_vm.$refs.drawer.drawer)}}),_c('v-main',[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }